import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { injectIntl, FormattedMessage, defineMessages } from 'react-intl';

import { getUrlHostname } from '../../../../utils/url';

const messages = defineMessages({
  freshman: {
    id: 'hubs.admissions.application-info.fees.freshman',
    defaultMessage: 'Freshman',
  },
  transfer: {
    id: 'hubs.admissions.application-info.fees.transfer',
    defaultMessage: 'Transfer',
  },
  international: {
    id: 'hubs.admissions.application-info.fees.international',
    defaultMessage: 'International',
  },
  applicationFee: {
    id: 'hubs.admissions.application-info.fees.application-fee',
    defaultMessage: 'Application Fee',
  },
  deposit: {
    id: 'hubs.admissions.application-info.fees.deposit',
    defaultMessage: 'Deposit',
  },
  footerText: {
    id: 'hubs.admissions.application-info.fees.footer-text',
    defaultMessage: '**Learn more about this at {url}',
  },
});

const parser = value =>
  Number(value).toLocaleString('en-US', {
    minimumFractionDigits: 0,
  });

const isValidValue = value => value && !Number.isNaN(Number(value)) && Number(value) > 0;

const getFeeTable = (headingMsg, appFeeValue, depositValue, intl) => {
  return (
    <div className="fees-tab-container-table">
      <h3 role="columnheader" aria-label={intl.formatMessage(headingMsg)}>
        <FormattedMessage {...headingMsg} />
      </h3>
      <div role="cell" aria-label={intl.formatMessage(messages.applicationFee)}>
        <span>
          <FormattedMessage {...messages.applicationFee} />:{' '}
        </span>{' '}
        {isValidValue(appFeeValue) ? `$${parser(appFeeValue)}` : '**'}
      </div>
      <div role="cell" aria-label={intl.formatMessage(messages.deposit)}>
        <span>
          <FormattedMessage {...messages.deposit} />:{' '}
        </span>{' '}
        {isValidValue(depositValue) ? `$${parser(depositValue)}` : '**'}
      </div>
    </div>
  );
};

const FeesTab = ({ fees, websiteUrl, intl }) => {
  const freshmanAppFee = get(fees, 'applicationFee.value', '');
  const freshmanDeposit = get(fees, 'deposit.value', '');
  const transferAppFee = get(fees, 'transferApplicationFee.value', '');
  const transferDeposit = get(fees, 'transferDepositFee.value', '');
  const intAppFee = get(fees, 'internationalApplicationFee.value', '');
  const intDeposit = get(fees, 'internationalDepositFee.value', '');

  return (
    <React.Fragment>
      <div
        className="application-information-tab fees-tab-container"
        data-cy="application-information-tab"
        role="table"
        aria-label="Fees information"
      >
        {getFeeTable(messages.freshman, freshmanAppFee, freshmanDeposit, intl)}
        {getFeeTable(messages.transfer, transferAppFee, transferDeposit, intl)}
        {getFeeTable(messages.international, intAppFee, intDeposit, intl)}
      </div>
      {websiteUrl && (
        <a
          data-cy="application-info-fees-footer"
          className="fee-footer"
          href={websiteUrl}
          aria-label="college website"
          target="_blank"
          rel="noopener noreferrer"
        >
          {intl.formatMessage(messages.footerText, { url: getUrlHostname(websiteUrl) })}
        </a>
      )}
    </React.Fragment>
  );
};

FeesTab.propTypes = {
  fees: PropTypes.object,
  websiteUrl: PropTypes.string,
  intl: PropTypes.object,
};

export default injectIntl(FeesTab);
